import React from 'react';

import type { WidgetProps } from '@rjsf/utils';

import { Button } from '@mui/material';

export default function ResetPasswordWidget({ id, value, disabled, readonly, onChange }: WidgetProps) {
  return (
    <Button
      id={id}
      type="button"
      variant="text"
      sx={{ alignSelf: 'flex-start' }}
      disabled={disabled || readonly}
      aria-expanded={Boolean(value)}
      onClick={() => onChange(!value, undefined, id)}
    >
      {value ? 'Cancel password reset' : 'Reset password'}
    </Button>
  );
}
